<template>
    <div class="customers-info-section">
        <div class="row">
            <div class="col-md-3 col-sm-12 text-center profile-image-section">
                <div v-if="customerDetails.pictureURL" class="customer-profile">
                    <img v-authenticated-image="customerDetails.pictureURL" />
                </div>

                <base-status
                    v-if="customerDetails.status"
                    :status-type="customerDetails.status"
                ></base-status>
            </div>
            <div
                v-if="localStorageTemSegment === 'Corporate'"
                class="col-md-9 col-sm-12"
            >
                <ul>
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>Customer Information</h3>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Idenfo ID:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.idenfoId
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Client ID:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.clientId
                                                    ? customerDetails.clientId
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>First Name:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.firstName
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <!-- <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Middle Name:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.middleName
                                                    ? customerDetails.middleName
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div> -->
                                <!-- <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>ID Number:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.identityInfo
                                                    .number
                                                    ? customerDetails
                                                          .identityInfo.number
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div> -->
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label
                                                >Date of Incorporation:</label
                                            >
                                        </li>
                                        <li class="col-md-6">
                                            <span>{{
                                                customerDetails.dateOfBirth
                                                    | moment('MMM D, YYYY')
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Record Last Updated:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                v-if="customerDetails.updatedAt"
                                                >{{
                                                    customerDetails.updatedAt
                                                        | moment('MMM D, YYYY')
                                                }}</span
                                            >
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <ul v-if="customerDetails.contactInfo">
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>Contact Information</h3>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Address:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.contactInfo
                                                    .address !== null
                                                    ? customerDetails
                                                          .contactInfo.address
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>City:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.contactInfo
                                                    .city !== null
                                                    ? customerDetails
                                                          .contactInfo.city
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>State:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.contactInfo
                                                    .state.length !== 0
                                                    ? customerDetails
                                                          .contactInfo.state[0]
                                                          .title
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Postal Code:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.contactInfo
                                                    .postalCode !== null
                                                    ? customerDetails
                                                          .contactInfo
                                                          .postalCode
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <!-- <ul v-if="customerDetails.occupationInfo">
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12"><h3>Occupation</h3></div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Work Type:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.occupationInfo
                                                    .workType[0].title
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Industry:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                v-if="
                                                    customerDetails
                                                        .occupationInfo.industry
                                                        .length
                                                "
                                                class=""
                                                >{{
                                                    customerDetails
                                                        .occupationInfo
                                                        .industry[0].title
                                                }}</span
                                            >
                                            <span v-else>N/A</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Tax ID:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                v-if="
                                                    customerDetails
                                                        .occupationInfo.taxId
                                                "
                                                class=""
                                                >{{
                                                    customerDetails
                                                        .occupationInfo.taxId
                                                }}</span
                                            >
                                            <span v-else>N/A</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul> -->
                <ul v-if="customerDetails.identityInfo">
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>ID Document</h3>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>CUIN:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.CUIN !== null
                                                    ? customerDetails.CUIN
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>NTN:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.identityInfo
                                                    .number !== null
                                                    ? customerDetails
                                                          .identityInfo.number
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <!-- <ul v-if="customerDetails.accountInfo">
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>Account Information</h3>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Purpose of action:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.accountInfo
                                                    .purposeOfAction[0].title
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Product Type:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.accountInfo.products
                                                    .map((e) => e.title)
                                                    .join(', ')
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Expected Credit:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class=""
                                                >{{
                                                    customerDetails.accountInfo
                                                        .expectedCredit
                                                }}
                                                (Monthly turnover)</span
                                            >
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label
                                                >Max Upper Credit Limit:</label
                                            >
                                        </li>
                                        <li class="col-md-6">
                                            <span class=""
                                                >{{
                                                    customerDetails.accountInfo
                                                        .creditLimit
                                                }}
                                                (Expected in month)</span
                                            >
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Channel Mode:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                v-if="
                                                    customerDetails.accountInfo
                                                        .registrationChannel &&
                                                    customerDetails.accountInfo
                                                        .registrationChannel
                                                        .length
                                                "
                                                class=""
                                                >{{
                                                    customerDetails.accountInfo
                                                        .registrationChannel[0]
                                                        .title
                                                }}</span
                                            >
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label
                                                >Gross Income of Client:</label
                                            >
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.accountInfo
                                                    .grossIncome
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Initial Balance:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.accountInfo
                                                    .initialBalance
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div
                                    v-for="(product, index) in customerDetails
                                        .accountInfo.products"
                                    :key="index"
                                    class="col-md-6"
                                >
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>{{ product.title }}</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                product.number
                                                    ? product.number
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Account Opening Date:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">
                                                {{
                                                    customerDetails.createdAt
                                                        | moment('MMM D, YYYY')
                                                }}</span
                                            >
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul> -->
                <!-- <ul v-if="customerDetails.diligenceStatus">
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>On-Going Due Diligence</h3>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Last Review:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                v-if="
                                                    customerDetails
                                                        .diligenceStatus
                                                        .lastReview
                                                "
                                                >{{
                                                    customerDetails
                                                        .diligenceStatus
                                                        .lastReview
                                                        | moment('MMM D, YYYY')
                                                }}</span
                                            >
                                            <span
                                                v-if="
                                                    !customerDetails
                                                        .diligenceStatus
                                                        .lastReview
                                                "
                                                >N/A</span
                                            >
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Next Review:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="danger">{{
                                                customerDetails.diligenceStatus
                                                    .nextReview
                                                    | moment('MMM D, YYYY')
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Expiry Date:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                :class="
                                                    addDangerClass(
                                                        customerDetails
                                                            .diligenceStatus
                                                            .expiryDate
                                                    )
                                                "
                                                >{{
                                                    customerDetails
                                                        .diligenceStatus
                                                        .expiryDate
                                                        | moment('MMM D, YYYY')
                                                }}</span
                                            >
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul> -->
                <!-- <ul
                    v-if="
                        customerDetails.customInfo &&
                            Object.keys(customerDetails.customInfo).length
                    "
                >
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>Additional Information</h3>
                                </div>
                                <div
                                    class="col-md-6"
                                    v-for="(info,
                                    index) in customerDetails.customInfo"
                                    :key="index"
                                >
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>{{ info.title }}</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                v-if="info.type == 'text-field'"
                                                >{{ info.value }}</span
                                            >
                                            <span
                                                v-if="info.type == 'text-area'"
                                                >{{ info.value }}</span
                                            >
                                            <span
                                                v-if="
                                                    info.type ==
                                                        'date-picker' &&
                                                        !!info.value
                                                "
                                                >{{
                                                    info.value
                                                        | moment('MMM D, YYYY')
                                                }}</span
                                            >
                                            <span
                                                v-if="
                                                    info.type ==
                                                        'date-picker' &&
                                                        !info.value
                                                "
                                                >N/A</span
                                            >
                                            <span
                                                v-if="info.type == 'dropdown'"
                                                >{{ info.value }}</span
                                            >
                                            <span v-if="info.type == 'radio'">{{
                                                info.value
                                            }}</span>
                                            <span
                                                v-if="
                                                    info.type == 'checkbox' &&
                                                        info.value
                                                "
                                                >{{
                                                    info.value.join(', ')
                                                }}</span
                                            >
                                            <span
                                                v-if="
                                                    info.type == 'checkbox' &&
                                                        !info.value
                                                "
                                            >
                                                N/A
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul> -->
            </div>
            <div v-else class="col-md-9 col-sm-12">
                <ul>
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>Customer Information</h3>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Idenfo ID:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.idenfoId
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Client ID:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.clientId
                                                    ? customerDetails.clientId
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>First Name:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.firstName
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <!-- <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Middle Name:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.middleName
                                                    ? customerDetails.middleName
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div> -->
                                <!-- <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>ID Number:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.identityInfo
                                                    .number
                                                    ? customerDetails
                                                          .identityInfo.number
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div> -->
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Father/Husband Name:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.fatherHusbandName
                                                    ? customerDetails.fatherHusbandName
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Gender:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.gender
                                                    ? customerDetails.gender
                                                          .title
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Date of Birth:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                v-if="
                                                    customerDetails.dateOfBirth
                                                "
                                                >{{
                                                    customerDetails.dateOfBirth
                                                        | moment('MMM D, YYYY')
                                                }}</span
                                            >
                                        </li>
                                    </ul>
                                </div>

                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Country of Residence:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                :class="{
                                                    danger: customerDetails.countryOfResidenceIsSanction,
                                                }"
                                                >{{
                                                    customerDetails.countryOfResidence
                                                        ? customerDetails
                                                              .countryOfResidence
                                                              .title
                                                        : 'N/A'
                                                }}</span
                                            >
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Nationality:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                :class="{
                                                    danger: customerDetails.nationalityIsSanction,
                                                }"
                                                >{{
                                                    customerDetails.nationality
                                                        ? customerDetails
                                                              .nationality.title
                                                        : 'N/A'
                                                }}</span
                                            >
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Record Last Updated:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                v-if="customerDetails.updatedAt"
                                                >{{
                                                    customerDetails.updatedAt
                                                        | moment('MMM D, YYYY')
                                                }}</span
                                            >
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <ul v-if="customerDetails.contactInfo">
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>Contact Information</h3>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Address:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.contactInfo
                                                    .address !== null
                                                    ? customerDetails
                                                          .contactInfo.address
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>City:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.contactInfo
                                                    .city !== null
                                                    ? customerDetails
                                                          .contactInfo.city
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>State:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span>{{
                                                customerDetails.contactInfo
                                                    .state.length !== 0
                                                    ? customerDetails
                                                          .contactInfo.state[0]
                                                          .title
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>

                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Postal Code:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.contactInfo
                                                    .postalCode !== null
                                                    ? customerDetails
                                                          .contactInfo
                                                          .postalCode
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <!-- <ul v-if="customerDetails.occupationInfo">
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12"><h3>Occupation</h3></div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Work Type:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.occupationInfo
                                                    .workType[0].title
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Industry:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                v-if="
                                                    customerDetails
                                                        .occupationInfo.industry
                                                        .length
                                                "
                                                class=""
                                                >{{
                                                    customerDetails
                                                        .occupationInfo
                                                        .industry[0].title
                                                }}</span
                                            >
                                            <span v-else>N/A</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Tax ID:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                v-if="
                                                    customerDetails
                                                        .occupationInfo.taxId
                                                "
                                                class=""
                                                >{{
                                                    customerDetails
                                                        .occupationInfo.taxId
                                                }}</span
                                            >
                                            <span v-else>N/A</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul> -->
                <ul v-if="customerDetails.identityInfo">
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>ID Document</h3>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Document Type:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.identityInfo
                                                    .type | identityInfoType
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>ID Number:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.identityInfo
                                                    .number
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Expiry Date:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                :class="
                                                    addDangerClass(
                                                        customerDetails
                                                            .identityInfo
                                                            .expiryDate
                                                    )
                                                "
                                                >{{
                                                    customerDetails.identityInfo
                                                        .expiryDate
                                                        | moment('MMM D, YYYY')
                                                }}</span
                                            >
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <!-- <ul v-if="customerDetails.accountInfo">
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>Account Information</h3>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Purpose of action:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.accountInfo
                                                    .purposeOfAction[0].title
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Product Type:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.accountInfo.products
                                                    .map((e) => e.title)
                                                    .join(', ')
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Expected Credit:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class=""
                                                >{{
                                                    customerDetails.accountInfo
                                                        .expectedCredit
                                                }}
                                                (Monthly turnover)</span
                                            >
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label
                                                >Max Upper Credit Limit:</label
                                            >
                                        </li>
                                        <li class="col-md-6">
                                            <span class=""
                                                >{{
                                                    customerDetails.accountInfo
                                                        .creditLimit
                                                }}
                                                (Expected in month)</span
                                            >
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Channel Mode:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                v-if="
                                                    customerDetails.accountInfo
                                                        .registrationChannel &&
                                                    customerDetails.accountInfo
                                                        .registrationChannel
                                                        .length
                                                "
                                                class=""
                                                >{{
                                                    customerDetails.accountInfo
                                                        .registrationChannel[0]
                                                        .title
                                                }}</span
                                            >
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label
                                                >Gross Income of Client:</label
                                            >
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.accountInfo
                                                    .grossIncome
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Initial Balance:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                customerDetails.accountInfo
                                                    .initialBalance
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div
                                    v-for="(product, index) in customerDetails
                                        .accountInfo.products"
                                    :key="index"
                                    class="col-md-6"
                                >
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>{{ product.title }}</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">{{
                                                product.number
                                                    ? product.number
                                                    : 'N/A'
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Account Opening Date:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="">
                                                {{
                                                    customerDetails.createdAt
                                                        | moment('MMM D, YYYY')
                                                }}</span
                                            >
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul> -->
                <!-- <ul v-if="customerDetails.diligenceStatus">
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>On-Going Due Diligence</h3>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Last Review:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                v-if="
                                                    customerDetails
                                                        .diligenceStatus
                                                        .lastReview
                                                "
                                                >{{
                                                    customerDetails
                                                        .diligenceStatus
                                                        .lastReview
                                                        | moment('MMM D, YYYY')
                                                }}</span
                                            >
                                            <span
                                                v-if="
                                                    !customerDetails
                                                        .diligenceStatus
                                                        .lastReview
                                                "
                                                >N/A</span
                                            >
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Next Review:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span class="danger">{{
                                                customerDetails.diligenceStatus
                                                    .nextReview
                                                    | moment('MMM D, YYYY')
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>Expiry Date:</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                :class="
                                                    addDangerClass(
                                                        customerDetails
                                                            .diligenceStatus
                                                            .expiryDate
                                                    )
                                                "
                                                >{{
                                                    customerDetails
                                                        .diligenceStatus
                                                        .expiryDate
                                                        | moment('MMM D, YYYY')
                                                }}</span
                                            >
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul> -->
                <!-- <ul
                    v-if="
                        customerDetails.customInfo &&
                            Object.keys(customerDetails.customInfo).length
                    "
                >
                    <li>
                        <div class="seprator-section">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>Additional Information</h3>
                                </div>
                                <div
                                    class="col-md-6"
                                    v-for="(info,
                                    index) in customerDetails.customInfo"
                                    :key="index"
                                >
                                    <ul class="row">
                                        <li class="col-md-6">
                                            <label>{{ info.title }}</label>
                                        </li>
                                        <li class="col-md-6">
                                            <span
                                                v-if="info.type == 'text-field'"
                                                >{{ info.value }}</span
                                            >
                                            <span
                                                v-if="info.type == 'text-area'"
                                                >{{ info.value }}</span
                                            >
                                            <span
                                                v-if="
                                                    info.type ==
                                                        'date-picker' &&
                                                        !!info.value
                                                "
                                                >{{
                                                    info.value
                                                        | moment('MMM D, YYYY')
                                                }}</span
                                            >
                                            <span
                                                v-if="
                                                    info.type ==
                                                        'date-picker' &&
                                                        !info.value
                                                "
                                                >N/A</span
                                            >
                                            <span
                                                v-if="info.type == 'dropdown'"
                                                >{{ info.value }}</span
                                            >
                                            <span v-if="info.type == 'radio'">{{
                                                info.value
                                            }}</span>
                                            <span
                                                v-if="
                                                    info.type == 'checkbox' &&
                                                        info.value
                                                "
                                                >{{
                                                    info.value.join(', ')
                                                }}</span
                                            >
                                            <span
                                                v-if="
                                                    info.type == 'checkbox' &&
                                                        !info.value
                                                "
                                            >
                                                N/A
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul> -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    // End of Component > mounted

    /*
    |--------------------------------------------------------------------------
    | Component > filters
    |--------------------------------------------------------------------------
    */
    filters: {
        identityInfoType: function (value) {
            switch (value) {
                case 'id':
                    return 'National ID Card'

                case 'licence':
                    return 'Driving Licence'

                case 'passport':
                    return 'Passport'
            }
        },
    },
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        customerDetails: {
            type: Object,
            default: null,
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            localStorageTemSegment: localStorage.getItem('dataSegmentType'),
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {}, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {}, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        addDangerClass(date) {
            let expiryDate = this.$moment(date)
            let diff = expiryDate.diff(this.$moment(), 'days')
            if (diff <= 60) {
                return 'danger'
            }
            return ''
        },
    }, // End of Component > filters
} // End of export default
</script>
